var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"q-highlighted-search-string",style:(_vm.computedStyle)},[(!_vm.items.length)?_c('span',[_vm._v(_vm._s(_vm.item))]):[_vm._l((_vm.items),function(item,idx){return [(_vm.needSpace(idx))?[_vm._v(" ")]:_vm._e(),_c('span',{key:idx,class:item.highlighted && 'highlighted-item'},[_vm._v(" "+_vm._s(item.value)+" ")])]})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }